import React from "react";
import styles from "./Footer.module.scss";
import classNames from "classnames/bind";
import FooterType from "./types";

const cx = classNames.bind(styles);

// TODO: this component is not necessary. also this should be moved to the "Pages" folder.
/**
 * A wrapper component that fixes its children to the bottom of the viewport
 */
const Footer = ({ children, align = "right" }: FooterType) => {
  return <footer className={cx("footer", align)}>{children}</footer>;
};

export default Footer;
